import { render, staticRenderFns } from "./ModuleEthBlocksMyBlocks.vue?vue&type=template&id=1fd0cfdd&scoped=true"
import script from "./ModuleEthBlocksMyBlocks.vue?vue&type=script&lang=js"
export * from "./ModuleEthBlocksMyBlocks.vue?vue&type=script&lang=js"
import style0 from "./ModuleEthBlocksMyBlocks.vue?vue&type=style&index=0&id=1fd0cfdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd0cfdd",
  null
  
)

export default component.exports